<div
  class="flex flex-row items-center justify-center"
  [ngClass]="{
    'h-full w-full': isProduct,
    'default-style': styleType === 'default',
    'card-style': styleType === 'card',
    'configurator-style': styleType === 'configurator',
    'no-full-width': noFullWidth,
  }"
>
  <div
    class="flex w-full flex-row"
    [class.buttons-container]="!isProductCard"
    [ngClass]="{ 'button-product': isProduct, 'button-product-card': isProductCard }"
  >
    @if (!inOrderDetail) {
      <ion-button
        class="stepper-button"
        slot="only-icon"
        [size]="size"
        fill="clear"
        color="dark"
        (click)="onQtyChange($event, -1)"
        [disabled]="qty - 1 < min || disabled"
        [class.white]="whiteBackground"
        [class.reduced]="reduced"
      >
        <ion-icon name="remove"></ion-icon>
      </ion-button>
    }
    <div
      *ngIf="showQty"
      class="showQty flex flex-row items-center justify-center gap-2.5"
      [class.reduced]="reduced"
      [ngClass]="{ 'showQty-product': isProduct, 'showQty-product-card': isProductCard }"
    >
      <span *ngIf="isFolder" class="qty-label">Copias:&nbsp;</span>
      <span>{{ qty }}</span>
    </div>

    @if (!inOrderDetail) {
      <ion-button
        class="stepper-button"
        slot="only-icon"
        [size]="size"
        fill="clear"
        color="dark"
        (click)="onQtyChange($event, +1)"
        [disabled]="qty + 1 > max || disabled"
        [ngClass]="{ disabled: disabled }"
        [class.white]="whiteBackground"
        [class.reduced]="reduced"
      >
        <ion-icon name="add"></ion-icon>
      </ion-button>
    }
  </div>
</div>
